import { Component, ErrorInfo, ReactNode } from "react";
import Status500 from "src/content/pages/Status/Status500";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: string;
  errorDetail: string;
  cause?: any;
  name?: string;
}

const CHUNK_RELOAD_KEY = 'chunk_reload_count';

function isChunkLoadError(error: Error): boolean {
  return (
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Loading CSS chunk') ||
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Importing a module script failed')
  );
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: "",
      errorDetail: ""
    };
  }

  static getDerivedStateFromError(err: Error): State {
    if (isChunkLoadError(err)) {
      const count = parseInt(sessionStorage.getItem(CHUNK_RELOAD_KEY) || '0');
      if (count < 3) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, String(count + 1));
        window.location.reload();
        return { hasError: false, error: '', errorDetail: '' };
      }
    }
    return { hasError: true, error: err.message, errorDetail: err.stack };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (!isChunkLoadError(error)) {
      this.setState({
        ...this.state,
        error: error.message,
        errorDetail: error.stack,
        name: error.name
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <Status500
        error={this.state.error}
        errorDetail={this.state.errorDetail}
      />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
